import React, {useState} from 'react'
import {Navigate} from 'react-router-dom'
import logo from '../../assets/Milidou/Logo DR Milidou V2-1-2.png'

function MenuParams() {
  const [goToHome, setgoToHome] = useState(false)
  const [goToContact, setGoToContact] = useState(false)
  const [goToDRclassique, setGoToDRclassique] = useState(false)
  function handleClick(){
    setgoToHome(true)
  }
  function handleContacter(event){
    event.preventDefault()
    setGoToContact(true)
  }
  function handleRetourDR(event){
    event.preventDefault()
    setGoToDRclassique(true)
  }
  if(goToHome) {
    return <Navigate push to={`/diagoriskMildiou/accueil`}/>
  }
  
  if(goToContact) {
    return <Navigate push to={`/nouscontacter`} />
  }
  if(goToDRclassique) {
    return <Navigate push to={`/simulations`} />
  }

  return (
    <div className='containerMildiouSimple' style={{backgroundColor:'#FFF7F7', height: '105vh'}}>
      <div> 
        <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '10px', height:'5vh'}}>
          <button
            onClick={handleClick}
            style={{
              backgroundColor: 'transparent',
              color: '#C61717',
              border: 'none',
              fontSize: '40px',
              cursor: 'pointer',
            }}
          >
            Retour à l'accueil {'>'}
          </button>
        </div>
        <img src={logo} alt="logo DiagoRisk" style={{height:'35vh', marginTop:'3vh'}}/>
        
        <div style={{display:'flex', flexDirection:'column', justifyContent:'space-between', marginTop:'5vh', height:'52vh'}}>
          <div style={{display:'flex', flexDirection:'column', alignItems:'flex-start'}}>
            <button className='buttonParamsMenu' onClick={handleContacter}> Contact </button>
            <button className='buttonParamsMenu' style={{marginTop:'2vh'}}> Mentions légales </button>
            <button className='buttonParamsMenu' style={{marginTop:'2vh'}}> Assurance </button>
            <button className='buttonParamsMenu' onClick={handleRetourDR} style={{marginTop:'2vh'}}> DiagoRisk 2050 </button>
          </div>
          <div style={{display:'flex', flexDirection:'column', alignItems:'flex-start'}}>
            <button className='buttonParamsMenu'> Paramètres </button>
            <button className='buttonParamsMenu' style={{marginTop:'2vh'}}> Mon compte </button>
            <button className='buttonParamsMenu' style={{marginTop:'7vh', color: '#C61717'}}> Déconnexion </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MenuParams